import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Form,
  Segment,
} from 'semantic-ui-react';
import { required } from '@mhub/web-validations';

import AppForm from './AppForm';
import { flashErrorMessage } from '../actions/flash';
import { fetchHimsDistricts } from '../actions/himsDistricts';
import STATES from '../constants/states';

class SearchHimsDistricts extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    state: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    himsDistricts: PropTypes.shape({
      data: PropTypes.array,
    }),
    validateRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
  }
  static mapStateToProps = state => ({
    himsDistricts: state.himsDistricts,
  })
  static getPropsToState = (props) => {
    let value = props.value || '';
    const noResultsMessage = 'Loading...';

    const { himsDistricts, state } = props;
    let districts = [];
    if (himsDistricts && himsDistricts.data && himsDistricts.data.length > 0) {
      const srState = STATES.find(s => s.value === state);
      if (srState) {
        const himsState = himsDistricts.data.find(hs => hs.id === srState.kod_negeri_id);
        if (himsState && himsState.districts) {
          districts = himsState.districts.map(c => ({
            key: c.id,
            value: c.id,
            kod_negeri_id: c.kod_negeri_id,
            kod_daerah_id: c.kod_daerah_id,
            text: c.keterangan,
          }));
        }
      }
    }

    if (districts.length > 0 && value) {
      const himsDistrict = districts.find(c => c.value === value);
      if (!himsDistrict) {
        value = '';
      }
    }

    return {
      value,
      noResultsMessage,
      districts,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchHimsDistricts.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentDidMount() {
    const { store } = this.context;
    store.dispatch(fetchHimsDistricts(false))
      .catch(err => store.dispatch(flashErrorMessage(err)));
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchHimsDistricts.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, data) => {
    let { value } = data;
    const district = this.state.districts.find(c => c.value === value);
    if (!district) {
      value = '';
    }
    this.setState({ value }, () => {
      if (district && this.props.onSelect) {
        this.props.onSelect(district);
      }
    });
  }
  handleOnError = (isError) => {
    this.setState({ error: isError });
  }
  render() {
    const { name } = this.props;
    const { districts, value, error } = this.state;
    return (
      <Segment className={`hims-address ${error ? 'error' : ''}`}>
        <AppForm.Validate
          ref={this.props.validateRef}
          validation={[required]}
          onChange={this.handleOnChange}
          validateLabel="HIMS City"
          onError={this.handleOnError}
        >
          <Form.Select
            name={name}
            fluid
            options={districts}
            placeholder="City*"
            label={(
              <Fragment>
                <label htmlFor={name}>City*</label>
                <p>Required by HIMS</p>
              </Fragment>
            )}
            search
            selectOnBlur={false}
            value={value}
          />
        </AppForm.Validate>
      </Segment>
    );
  }
}

export default connect(SearchHimsDistricts.mapStateToProps)(SearchHimsDistricts);



// WEBPACK FOOTER //
// ./src/components/SearchHimsDistricts.jsx